function fmtVal(v) {
  if (!v) return "R$ 0";
  return v >= 1000 ? "R$ " + (v / 1000).toFixed(1) + "k" : "R$ " + v;
}

function getStatusLabel(s) {
  var labels = { qualificacao: "Qualificacao", simulacao: "Simulacao", reuniao: "Reuniao", proposta: "Proposta", negociacao: "Negociacao", fechado: "Fechado", perdido: "Perdido" };
  return labels[s] || s;
}

function getStatusCls(s) {
  var cls = { qualificacao: "bg-gray-100 text-gray-700", simulacao: "bg-blue-100 text-blue-700", reuniao: "bg-purple-100 text-purple-700", proposta: "bg-amber-100 text-amber-700", negociacao: "bg-cyan-100 text-cyan-700", fechado: "bg-emerald-100 text-emerald-700", perdido: "bg-red-100 text-red-700" };
  return cls[s] || "bg-gray-100 text-gray-700";
}

function StatusItem({ status, count }) {
  var lbl = getStatusLabel(status);
  var cls = getStatusCls(status);
  return (
    <div className="flex items-center justify-between">
      <span className={"px-2 py-0.5 rounded-full text-xs font-medium " + cls}>{lbl}</span>
      <span className="text-sm font-semibold text-[#0A2F3D]">{count}</span>
    </div>
  );
}

function ProductItem({ product, total, value }) {
  return (
    <div className="flex items-center justify-between py-1">
      <span className="text-xs text-gray-600 capitalize">{product}</span>
      <span className="text-xs font-medium text-[#0A2F3D]">{total} leads / {fmtVal(value)}</span>
    </div>
  );
}

export default function SalesSidebar({ byStatus, byProduct }) {
  var statuses = byStatus || [];
  var products = byProduct || [];

  return (
    <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
      <h4 className="text-sm font-semibold text-[#0A2F3D] mb-4">Por Status</h4>
      <div className="space-y-2">
        {statuses.map(function(s) {
          return <StatusItem key={s.status} status={s.status} count={s.count} />;
        })}
      </div>
      {products.length > 0 && (
        <div className="mt-4 pt-4 border-t border-gray-100">
          <h5 className="text-xs font-medium text-gray-500 mb-2">Por Produto</h5>
          {products.map(function(p) {
            return <ProductItem key={p.product} product={p.product} total={p.total} value={p.value} />;
          })}
        </div>
      )}
    </div>
  );
}
